<ion-menu-button [autoHide]="!isMobile" (click)="openMenu()">
    <ion-icon name="menu"></ion-icon>
    <div class="smr-menu-badge">
      <ion-badge
        class="smr-menu-badge-icon"
        slot="end"
        color="danger"
        *ngIf="
          bookingRequestCount +
            bookingWaitListCount +
            onBoardingService.getUncompletedStepsCount() >
          0
        "
      >
        {{
          bookingRequestCount +
            bookingWaitListCount +
            onBoardingService.getUncompletedStepsCount()
        }}
      </ion-badge>
    </div>
  </ion-menu-button>